module.exports = __webpack_public_path__ + "media/save-time.2b41776d.webm";